import request from '@/utils/request'


// 查询直播列表
export function listLive(query) {
  return request({
    url: '/live/live/list',
    method: 'get',
    params: query
  })
}

// 查询直播分页
export function pageLive(query) {
  return request({
    url: '/live/live/page',
    method: 'get',
    params: query
  })
}

// 查询直播详细
export function getLive(data) {
  return request({
    url: '/live/live/detail',
    method: 'get',
    params: data
  })
}

export function getLiveGoods(data) {
  return request({
    url: '/live/live/goodsList',
    method: 'get',
    params: data
  })
}
export function editLiveRecommend(data) {
  return request({
    url: '/live/live/editLiveRecommend',
    method: 'post',
    params: data
  })
}
export function editLivePrice(data) {
  return request({
    url: '/live/live/editLivePrice',
    method: 'post',
    params: data
  })
}
export function shangjia(data) {
  return request({
    url: '/live/live/shangjia',
    method: 'get',
    params: data
  })
}
export function xiajia(data) {
  return request({
    url: '/live/live/xiajia',
    method: 'get',
    params: data
  })
}
export function deleteLiveGoods(data) {
  return request({
    url: '/live/live/deleteLiveGoods',
    method: 'get',
    params: data
  })
}
export function addLiveGoods(data) {
  return request({
    url: '/live/live/addGoodsToLiveRoom',
    method: 'post',
    params: data
  })
}
// 添加秒杀商品到直播间
export function addSeckillGoodsToLiveRoom(data) {
  return request({
    url: '/live/live/addSeckillGoodsToLiveRoom',
    method: 'post',
    data: data
  })
}
export function getLiveCoupon(data) {
  return request({
    url: '/live/live/liveCouponList',
    method: 'get',
    params: data
  })
}
export function liveGiftCouponList(data) {
  return request({
    url: '/live/live/liveGiftCouponList',
    method: 'get',
    params: data
  })
}export function addLottery(data) {
  return request({
    url: '/live/live/addLottery',
    method: 'post',
    params: data
  })
}
// 新增直播
export function addLive(data) {
  return request({
    url: '/live/live/add',
    method: 'post',
    data: data
  })
}

// 修改直播
export function updateLive(data) {
  return request({
    url: '/live/live/edit',
    method: 'post',
    data: data
  })
}
//发红包
export function addRedPacket(data) {
  return request({
    url: '/live/live/addRedPacket',
    method: 'post',
    data: data
  })
}

export function addLiveCoupon(data) {
  return request({
    url: '/live/live/addLiveCoupon',
    method: 'post',
    data: data
  })
}
export function shopUserList(data) {
  return request({
    url: '/live/live/shopUserList',
    method: 'get',
    data: data
  })
}

export function userList(data) {
  return request({
    url: '/live/live/userList',
    method: 'get',
    data: data
  })
}
// 删除直播
export function delLive(data) {
  return request({
    url: '/live/live/delete',
    method: 'post',
    data: data
  })
}
// 关闭直播
export function endLive(data) {
  return request({
    url: '/live/live/endLive',
    method: 'post',
    data: data
  })
}
// 开启直播
export function startLive(data) {
  return request({
    url: '/live/live/startLive',
    method: 'post',
    data: data
  })
}
export function createHuizhi(data) {
  return request({
    url: '/live/live/createHuizhi',
    method: 'get',
    params: data
  })
}
// 查询直播统计信息
export function getLiveData(data) {
  return request({
    url: '/live/live/getLiveData',
    method: 'get',
    params: data
  })
}
export function getReceiveRedRecord(data) {
  return request({
    url: '/redpacket/packet/receive/record/page',
    method: 'get',
    params: data
  })
}
export function getLotterRecord(data) {
  return request({
    url: '/live/live/getLotterRecord',
    method: 'get',
    params: data
  })
}
// 查询直播在线人数统计
export function getMembersList(data) {
  return request({
    url: '/live/live/getMembersList',
    method: 'get',
    params: data
  })
}
